import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { warehouseValidationForm } from "../../utils/validationSchema";
import WarehosueForm from './WarehosueForm';
import Form from '../../layouts/Form';
const CreateWarehouse = (props: any) => {


  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    clearErrors
  } = useForm<any>({
    resolver: yupResolver(warehouseValidationForm),
  });
  const { handleCreate, isLoading } = props;
  return (
    <Form
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <WarehosueForm
        clearErrors={clearErrors}
        errors={errors}
        register={register}
        setValue={setValue}
        getValues={getValues}
      />
    </Form>
  );


}

export default CreateWarehouse
